import TopNavMenu, { isActive } from 'components/TopNavMenu';
import { MENUS } from 'constants/menus';
import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: 'white',
    padding: '14px 24px',
    display: 'flex',
  },
}));

const SubMenu = () => {
  const classes = useStyles();
  const location = useLocation();

  const subMenus =
    MENUS?.find((menu) => {
      const alias = menu?.subMenus?.map((subMenu) => subMenu.link) || [];
      return isActive(alias, location.pathname);
    })?.subMenus || [];

  if (subMenus.length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <TopNavMenu menus={subMenus} isParentMenu={false} />
    </div>
  );
};

export default SubMenu;
